import VueCqrs from '@cqrs/vue-component-cqrs';
import { PortfolioBalancerReportSettings } from '@Reports/Model';
import * as c from '@Reports/Reports/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class ReportsCommands extends VueCqrs {

	invokeDeleteReportCommandV1(workspaceId: number, reportId: string)
	{
		const cmd = new c.DeleteReportCommandV1(workspaceId, reportId);
		this.$command(cmd, reportId);
	}

	invokeCloneReportCommandV1(workspaceId: number, reportId: string, sourceId: string)
	{
		const cmd = new c.CloneReportCommandV1(workspaceId, reportId, sourceId);
		this.$command(cmd, reportId);
	}

	invokeUpdateReportCommandV1(workspaceId: number, reportId: string, name: string, description: string)
	{
		const cmd = new c.UpdateReportCommandV1(workspaceId, reportId, name, description);
		this.$command(cmd, reportId);
	}

	invokeCreateReportCommandV1(workspaceId: number, projectId: number, reportId: string, name: string, description: string)
	{
		const cmd = new c.CreateReportCommandV1(workspaceId, projectId, reportId, name, description);
		this.$command(cmd, reportId);
	}

	invokeUpdatePortfolioBalancerReportCommandV1(workspaceId: number, projectId: number, reportId: string, settings: PortfolioBalancerReportSettings)
	{
		const cmd = new c.UpdatePortfolioBalancerReportCommandV1(workspaceId, projectId, reportId, settings);
		this.$command(cmd, reportId);
	}
}
